/*
 *
 * ForgotPassword constants
 *
 */
export const REDUCER_KEY = 'ForgotPassword';
export const REQUEST_RESET_LINK = 'app/ForgotPassword/REQUEST_RESET_LINK';
export const RESET_REQUEST_RESET_LINK =
  'app/ForgotPassword/RESET_REQUEST_RESET_LINK';
